import { useListBoardingPassesQuery } from "services/boardingPasses";
import { BoardingPass } from "../boardingPass";
import { createTemplateDashboard } from 'components/reusable/template/list';


export const BoardingPassDashboard = createTemplateDashboard({
  TemplateRenderer: BoardingPass,
  listTemplateHook: useListBoardingPassesQuery,
  i18nNamespace: "boardingPass"
})